import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './core/services/auth.service';

/**
 * A focused `<input type="number">` steps its value on every wheel tick while the cursor is over
 * it, so an author scrolling the form past "Theme number" silently changed it. Blurring the input
 * on the wheel lets the scroll go to the page instead. Global and passive: it applies to every
 * number input in the CMS, and it never blocks the scroll itself.
 */
function blurNumberInputOnWheel(event: WheelEvent): void {
  const target = event.target;
  if (
    target instanceof HTMLInputElement &&
    target.type === 'number' &&
    target === document.activeElement
  ) {
    target.blur();
  }
}

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private readonly authService = inject(AuthService);

  ngOnInit(): void {
    document.addEventListener('wheel', blurNumberInputOnWheel, {
      passive: true,
    });
    if (!this.authService.currentUser && this.authService.isAuthenticated()) {
      this.authService.me().subscribe({ error: () => {} });
    }
  }
}
